import { Result, SessionProvider } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { Permission, Res } from 'core/api';
import { CashControl } from 'pos/services';
import { Message } from 'core/ui-next/modal';

declare global {
	interface CommandType {
		giveChangeFromCashControl: () => Promise<Result>
	}
}

Command.register('giveChangeFromCashControl', Preconditions.and(Preconditions.ensure(Permission.CashControl_GiveChange), Preconditions.ensureSlaveCanHandleCashOperations), async (): Promise<Result> => {

	if (!SessionProvider.getCurrent().UseCashControl) {
		await Message.show(Res.Msg.MSG_CASH_CONTROL_NOT_AVAILABLE());
		return Result.error();
	}

	await CashControl.giveChange();

	return Result.ok();
});